// extracted by mini-css-extract-plugin
export default {"mobileMaxWidth":"915px","desktopMinWidth":"1101px","desktopMaxWidth":"1450px","desktop":"only screen and (min-width: 1101px)"};